import { CardsServerPagination } from './CardsServerPagination';

export type { TypeCardsServerPaginationProps } from './types';
export default CardsServerPagination;
